// extracted by mini-css-extract-plugin
export default {"container":"cdz4n1zxd","white":"ch5ovdsp2","closeButtonHolder":"ci4gd4cl0"};